import { ajaxCatchSilently } from '@helper/api';
import { getProfiBazaApiClient } from '@services/ProfiBazaApi';
import React from 'react';

import Tags from './Tags';

interface IProps {
	documentId: string;
	tags: string[];
}

const DocumentTags: React.FC<IProps> = (props) => {
	const addTag = (
		tag: string,
		onSuccess: () => void,
		onError: () => void
	) => {
		ajaxCatchSilently(
			() =>
				getProfiBazaApiClient().then((api) =>
					api.documentTag.addTag({
						body: {
							sourceDocumentId: props.documentId,
							tagName: tag,
						},
					})
				),
			onSuccess,
			onError
		);
	};

	const removeTag = (tag: string, onError: () => void) => {
		ajaxCatchSilently(
			() =>
				getProfiBazaApiClient().then((api) =>
					api.documentTag.deleteTag({
						body: {
							sourceDocumentId: props.documentId,
							tagName: tag,
						},
					})
				),
			undefined,
			onError
		);
	};

	return (
		<Tags addTag={addTag} removeTag={removeTag} tags={props.tags}></Tags>
	);
};

export default DocumentTags;
